<template>
  <div class="contact">
    <nav class="tip-title __fs-16 _fw-500">联系我们</nav>
    <div class="conMap">
      <baidu-map class="bm-view" :center="center" :zoom="zoom" @ready="handler">
      <bm-geolocation
          anchor="BMAP_ANCHOR_BOTTOM_RIGHT"
          :autoLocation="true"
      ></bm-geolocation>
      <bm-marker :position="{lng: longtitude, lat: latitude}">
      </bm-marker>
      </baidu-map>
    </div>
    <div class="conInfo">
      <ul>
          <li>
          <div class="infoSmt">联系人</div>
          <div class="infoCon">{{this.name}}</div>
          </li>
          <li>
          <div class="infoSmt">电话</div>
          <div class="infoCon">{{this.phone}}</div>
          </li>
          <li>
          <div class="infoSmt">邮编</div>
          <div class="infoCon">{{this.postcode}}</div>
          </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { aliyun, building } from '@/agent'
export default {
  name: 'Contact',
  props: {
    list: {
      type: Array,
    }
  },
  data () {
    return {
      dataListAll: '',
      center: { lng: '', lat: '' },
      zoom: 15,
      show: true,
      longtitude: '',
      latitude: '',
      name: '',
      phone: '',
      postcode: '',

    }
  },
  mounted () {
    this.getcommunityContacts()
  },
  methods: {
    handler () {
      this.center.lng = this.longtitude
      this.center.lat = this.latitude
    },

    infoWindowOpen () {
      this.show = true
    },
    infoWindowClose () {
      this.show = false
    },
    // 点击swiper
    handleClickSlide (item) {
      this.$emit('handle-click-wonderful', item)
    },
    // 格式化阿里云地址
    formatAliyunPath (path) {
      return aliyun.getAliyunAddress(path)
    },
    // 获取组织信息
    getcommunityContacts () {
      building.communityContacts().then((res) => {
        if (res.code == 100) {
          this.dataListAll = res.data.org
          this.longtitude = Number(res.data.org.longtitude)
          this.latitude = Number(res.data.org.latitude)
          this.name = res.data.org.contactor
          this.postcode = res.data.org.postcode
          this.phone = res.data.org.phone
          this.handler()
        }
      })
    }
  },
}
</script>

<style scoped lang="scss">
.contact {
    margin-top: 36px;
    height:365px;
    position:relative;
    z-index:1;
    .tip-title {
      padding-left: 8px;
      border-left: 3px solid $main-color;
      border-radius: 2px;
      color: #282828;
      margin:0 20px 56px 20px;
    }
    .conMap {
      position: absolute;
      width: 100%;
      height: 290px;
      opacity: 1;
      background: #f2f2f2;
      box-sizing: border-box;
      z-index: 0;
      .bm-view {
        width: 100%;
        height: 100%;
      }
    }
    .conInfo {
      width: 335px;
      height: 60px;
      position: absolute;
      z-index:10;
      top:35px;
      left: 50%;
      transform: translate(-50%,0);
      opacity: 1;
      background: #ffffff;
      box-shadow: 8px 13px 0px NaNpx rgba(129,129,129,0.15);
      padding: 6px 0;
      box-sizing: border-box;
      ul{
        display: flex;
        justify-content: space-around;
        li{
          text-align: center;
          .infoSmt{
            opacity: 1;
            font-size: 10px;
            font-family: Microsoft YaHei, Microsoft YaHei-Regular;
            font-weight: 400;
            color: #828282;
            line-height: 24px;
          }
          .infoCon{
            opacity: 1;
            font-size: 12px;
            font-family: Microsoft YaHei, Microsoft YaHei-Regular;
            font-weight: 400;
            color: #252525;
            line-height: 24px;
          }
        }
      }
    }
}
</style>
